import { render, staticRenderFns } from "./DetalhesEspecialista.vue?vue&type=template&id=550a5504&scoped=true&lang=pug"
import script from "./DetalhesEspecialista.vue?vue&type=script&lang=js"
export * from "./DetalhesEspecialista.vue?vue&type=script&lang=js"
import style0 from "./DetalhesEspecialista.vue?vue&type=style&index=0&id=550a5504&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a5504",
  null
  
)

export default component.exports